import { gql } from '@apollo/client/core';

export const getTownships = gql`
  query getTownships {
    getTownships {
      id
      state
      county
      township
    }
  }
`;
